import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useAppSelector } from "Redux/hooks";
import ExitButton from "../Atoms/ExitButton";
import { leanEntries } from "Constants/defaultStyles";
import { selectStyle } from "Redux/appSlice";

/*
  @function Terms
  render a terms page that shows a stack of terms
  @params children {React.Node} - content to fill the page
  @returns {React.Node} 
*/
export default function Terms({
  children,
  isHalfPage = false,
  termListId = "term-list",
  onRemoveAll = () => {},
}: {
  children: React.ReactNode;
  isHalfPage: boolean;
  termListId: string;
  onRemoveAll: () => void;
}) {
  // TODO: why do we need this?
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [mouseOver, setMouseOver] = useState(false);

  const position = isHalfPage ? "74" : "0";

  useEffect(() => {
    function handleResize() {
      setScreenSize(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { color2 } = useAppSelector(selectStyle);

  return (
    <motion.div
      className={`absolute z-20 h-full pl-5 pt-32 lg:top-36 lg:pl-0 lg:pt-5 ${
        isHalfPage ? "w-[22vw]" : "w-full"
      } `}
      initial={{ x: "100vw" }}
      animate={{ x: `${position}vw` }}
      transition={{ type: "spring", damping: 30 }}
      style={{ background: leanEntries.color2 }}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="flex flex-row justify-between">
        <h1
          style={{ color: color2, borderColor: color2 }}
          className=" w-fit border-b-2 px-4 py-2 font-bold"
        >
          TERMS
        </h1>
        <div className="mr-12 md:mr-8 ">
          <ExitButton onClick={onRemoveAll} />
        </div>
      </div>

      <div
        className={`flex flex-col gap-8 ${
          isHalfPage ? "w-[20vw]" : "w-full"
        } ml-1 mt-8 h-[63vh] overflow-y-auto  pr-4`}
        id={termListId}
      >
        {children}
      </div>
    </motion.div>
  );
}
